/* Used for legacy reasons. Prefer the PublishingGroup model instead as it's fields have been normalized. */
class ChatterListingGroup {
  constructor(_id, name, provider, remoteIds, accountId) {
    this._id = _id;
    this.name = name;
    this.provider = provider; // 'Facebook', 'Google', 'Instagram', 'Twitter'.
    this.remoteIds = remoteIds;
    this.accountId = accountId;
  }

  toCreateRequest() {
    return { name: this.name, provider: this.provider, remoteIds: this.remoteIds, accountId: this.accountId };
  }
}

export default ChatterListingGroup;
